import { useState, useEffect } from "react";
import { collection, doc, onSnapshot } from "firebase/firestore";
import { db } from "../components/Auth/firebase";
import emailjs from "emailjs-com";

const useKanbanData = (projectId, boardId) => {
  const [tasks, setTasks] = useState(null);
  const [columns, setColumns] = useState(null);
  const [final, setFinal] = useState(null);
  const [boardName, setBoardName] = useState("");

  useEffect(() => {
    if (!projectId || !boardId) return;

    const unsubscribeTasks = onSnapshot(
      collection(db, `projects/${projectId}/boards/${boardId}/tasks`),
      (snap) => {
        const documents = [];
        snap.forEach((d) => {
          documents.push({ id: d.id, ...d.data() });
        });
        setTasks(documents);
      }
    );
    return unsubscribeTasks;
  }, [projectId, boardId]);

  useEffect(() => {
    if (!projectId || !boardId) return;

    const boardDocRef = doc(db, `projects/${projectId}/boards`, boardId);
    const unsubscribeBoardName = onSnapshot(boardDocRef, (docSnap) => {
      if (docSnap.exists()) {
        setBoardName(docSnap.data().name);
      }
    });
    return unsubscribeBoardName;
  }, [projectId, boardId]);

  useEffect(() => {
    if (!projectId || !boardId) return;

    const unsubscribeColumns = onSnapshot(
      collection(db, `projects/${projectId}/boards/${boardId}/columns`),
      (snap) => {
        const documents = [];
        snap.forEach((d) => {
          documents.push({ id: d.id, ...d.data() });
        });
        setColumns(documents);
      }
    );
    return unsubscribeColumns;
  }, [projectId, boardId]);

  useEffect(() => {
    if (tasks && columns) {
      const finalObject = {};
      const co = columns.find((c) => c.id === "columnOrder");
      const cols = columns.filter((c) => c.id !== "columnOrder");

      finalObject.columnOrder = co?.order;
      finalObject.columns = {};
      finalObject.tasks = {};

      tasks.forEach((t) => (finalObject.tasks[t.id] = t));
      cols.forEach((c) => (finalObject.columns[c.id] = c));

      setFinal(finalObject);

      // Check for tasks that are near their due date
      tasks.forEach((task) => {
        if (task.dueDate) {
          const now = new Date();
          const dueDate = task.dueDate.toDate();
          const timeDifference = dueDate - now;

          if (timeDifference > 0 && timeDifference <= 24 * 60 * 60 * 1000) {
            sendDeadlineReminder(task);
          }
        }
      });
    }
  }, [tasks, columns]);

  const sendDeadlineReminder = (task) => {
    if (!task.assignees || task.assignees.length === 0) return;

    task.assignees.forEach((assignee) => {
      const templateParams = {
        task_title: task.title,
        due_date: task.dueDate.toDate().toLocaleDateString(),
        email: assignee.email, // Send to each assignee's email
        assignee_name: assignee.name || "Team Member", // Use the assignee's name if available
      };

      emailjs
        .send(
          "service_q2w46v9",
          "template_t0n43bu",
          templateParams,
          "0cn_Xh3tTrBJG67ua"
        )
        .then((response) => {
          console.log(
            `Email sent successfully to ${assignee.email}!`,
            response.status,
            response.text
          );
        })
        .catch((error) => {
          console.error(`Failed to send email to ${assignee.email}:`, error);
        });
    });
  };

  return { initialData: final, setInitialData: setFinal, boardName };
};

export default useKanbanData;
